import React from 'react';
import { FM220 } from '../../../services/m209Api';

interface Tab1Props {
  formData: Partial<FM220>;
  isEditing: boolean;
  getField: (key: keyof FM220) => FM220[keyof FM220];
  setField: (key: keyof FM220, value: FM220[keyof FM220]) => void;
  isApproved: boolean;
}

/** Helper: convert ISO date string to input value */
const dateToInput = (v: FM220[keyof FM220]): string => {
  if (!v) return '';
  const s = String(v);
  return s.length >= 10 ? s.substring(0, 10) : s;
};

const Tab1BasicInfo: React.FC<Tab1Props> = ({ formData, isEditing, getField, setField, isApproved }) => {
  const isDisabled = !isEditing;

  return (
    <div className="m209-master-fields">
      {/* Row 1: 修改單號 + 已核准 + 修改日期 */}
      <div className="field-row">
        <div className="field-pair">
          <label>修改單號</label>
          <input type="text" readOnly value={(getField('fm220_01') as string) || ''} style={{ maxWidth: 120 }} />
          {isApproved && <span className="approved-label">已核准</span>}
        </div>
        <div className="field-pair">
          <label>修改日期</label>
          <input
            type="date"
            disabled={isDisabled}
            value={dateToInput(getField('fm220_11'))}
            onChange={e => setField('fm220_11', e.target.value || null)}
            style={{ maxWidth: 160 }}
          />
        </div>
      </div>

      {/* Row 2: 庫位代號 + 入單人員 */}
      <div className="field-row">
        <div className="field-pair">
          <label>庫位代號</label>
          <input type="text" readOnly value={(getField('fm220_14') as string) || ''} style={{ maxWidth: 100 }} />
        </div>
        <div className="field-pair">
          <label>入單人員</label>
          <input type="text" readOnly value={(getField('fm220_12') as string) || ''} style={{ maxWidth: 120 }} />
        </div>
      </div>

      {/* Row 3: 部門代號 */}
      <div className="field-row">
        <div className="field-pair">
          <label>部門代號</label>
          <input type="text" readOnly value={(getField('fm220_13') as string) || ''} style={{ maxWidth: 120 }} />
        </div>
      </div>
    </div>
  );
};

export default Tab1BasicInfo;
